import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VLayout,{staticClass:"mt-3",attrs:{"column":""}},[_c(VImg,{staticClass:"my-4",attrs:{"src":"/static/img/ld-powered-lw-logo.svg","height":"50","contain":""}}),_c(VIcon,{staticClass:"my-3",attrs:{"size":"100"}},[_vm._v("$vuetify.icons.verifying-info")]),_c('p',{staticClass:"message"},[_vm._v("Checking your information...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }